'use strict';

const servers = {
    eu: 'https://hyperchat-eu.inbenta.chat',
    us: 'https://hyperchat-us.inbenta.chat',
    jp: 'https://hyperchat-jp.inbenta.chat',
};

const defaultPort = 8000;

/**
 * Represents the SDK configuration (appId, server)
 */
class Conf {
    /**
     * Conf constructor with default server
     * @return {Conf} Conf instance with all configurations appended to it
     */
    constructor () {
        this.apiVersion = 'v1';
        this.server = '';
    }

    /**
     * Configuration method for setting the appId and/or alternative servers
     * @param {Object} conf Configuration object containing appId and server
     */
    set (conf) {
        const invalidServerError = 'A server URL or valid cloud region must be provided';

        if (!conf.appId) {
            throw new Error('An appId must be provided');
        }
        this.appId = conf.appId;

        if (!conf.server && !conf.region) {
            throw new Error(invalidServerError);
        }

        const port = conf.port || defaultPort;
        // if a region is provided and it's valid, get the correct url
        if (conf.region && (Object.keys(servers).indexOf(conf.region) !== -1)) {
            this.server = [servers[conf.region], port].join(':');
        } else if (conf.server) {
            const splittedUrl = conf.server.split(':');
            const portInUrl = splittedUrl[2];
            if (portInUrl) {
                this.server = conf.server;
            } else {
                this.server = [splittedUrl[0], splittedUrl[1], port].join(':');
            }
        } else {
            throw new Error(invalidServerError);
        }

        this.setCookieOnDomain = (conf.setCookieOnDomain === true);
        this.isAgent = conf.isAgent;
    }
}

module.exports = new Conf();



// WEBPACK FOOTER //
// ./src/Conf.js